import { combineReducers } from 'redux';
import spinner from './spinner';
import reportLinkDetail from './reports';
import editingReport from './editingReport';
import csvExport from './csvExport';
import nextReport from './nextReport';

const rootReducer = combineReducers({
  spinner,
  reportLinkDetail,
  editingReport,
  csvExport,
  nextReport,
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js